{
  "language": {
    "title": "言語を選択してください",
    "en": "English",
    "en_US": "English",
    "nl": "Nederlands",
    "sr": "Srpski",
    "fr": "Français",
    "de": "Deutsch",
    "pt": "Português",
    "es": "Español",
    "ja": "日本語",
    "pl": "Polski",
    "it": "Italiano"
  },
  "home": {
    "welcomeMessage": "こんにちは、どのようにお手伝いできますか？",
    "checkIn": "チェックイン",
    "independentManualCheckIn": "予約なし",
    "integratedManualCheckIn": "手動チェックイン",
    "checkOut": "チェックアウト",
    "manualCheckOut": "手動チェックアウト",
    "parcelDelivery": "荷物配達",
    "foodDelivery": "食品配達",
    "callReception": "受付に電話",
    "overview": "概要",
    "unavailable": "受付は現在利用できません。"
  },
  "check": {
    "option": {
      "checkin": {
        "title": "チェックインのオプションを選択してください",
        "manual": "手動チェックイン",
        "code": "PINまたはQRコードでチェックイン",
        "code-no-qr": "PINコードでチェックイン"
      },
      "checkout": {
        "title": "チェックアウトのオプションを選択してください",
        "manual": "名前でチェックアウト",
        "code": "PINまたはQRコードでチェックアウト",
        "code-no-qr": "PINコードでチェックアウト"
      }
    },
    "title": "QRコードをスキャンするか、PINコードを入力してください。",
    "orText": "または",
    "qrScanner": {
      "checkin": {
        "title": "チェックインのオプションを選択してください"
      },
      "checkout": {
        "title": "チェックアウトのオプションを選択してください"
      },
      "btn": "QRコードをスキャン"
    },
    "hidScanner": {
      "title": "QRコードを下のスキャナーにかざすか、PINコードを入力してください"
    },
    "pinOnly": {
      "title": "PINコードを入力してください"
    },
    "pinCode": "PINコードを入力してください",
    "manually": {
      "checkin": "チェックインコードをお持ちでないですか？"
    },
    "status": {
      "idle": {
        "title": "コードをスキャンしています。",
        "message": "お待ちください...",
        "nfc": {
          "title": "タグを読み取っています。",
          "message": "しばらくお待ちください…"
        }
      },
      "loading": {
        "title": "コードをスキャンしています。",
        "message": "お待ちください...",
        "nfc": {
          "title": "タグを読み取っています。",
          "message": "しばらくお待ちください…"
        }
      },
      "error": {
        "title": "コードが無効です。",
        "message": "もう一度お試しください！",
        "nfc": {
          "title": "無効なタグです。",
          "message": "もう一度お試しください。"
        },
        "meeting": {
          "tooEarly": {
            "title": "少し早すぎます",
            "message": "コードは {{validFromTime}} から有効です。会議は {{meetingStartTime}} に始まります。"
          },
          "tooLate": {
            "title": "このコードは期限切れです",
            "message": "会議は {{meetingEndTime}} に終了しました。コードは {{validUntilTime}} まで有効でした。"
          }
        }
      },
      "success": {
        "checkin": {
          "default": {
            "title": "チェックインが完了しました。",
            "message": "ありがとうございます。"
          },
          "MeetingAttendee": {
            "no-email-sms": {
              "title": "チェックインが完了しました。",
              "message": "ありがとうございます。"
            },
            "email-sms": {
              "title": "チェックインが完了しました。",
              "message": "担当者に通知されました。"
            },
            "call-ping": {
              "title": "チェックインが完了しました。",
              "message": "担当者との電話接続を開始します。"
            },
            "teams-call": {
              "title": "チェックインが完了しました。",
              "message": "担当者とのMicrosoft Teams通話を開始します。"
            },
            "badge": {
              "title": "チェックインありがとうございます。バッジが印刷されます。",
              "message": ""
            },
            "video-call": {
              "title": "チェックインが完了しました。",
              "message": "担当者とのビデオ通話を設定しています。"
            }
          },
          "Employee": {
            "title": "チェックインが完了しました。",
            "message": "ありがとうございます。",
            "badge": {
              "title": "チェックインありがとうございます。バッジが印刷されます。",
              "message": ""
            }
          },
          "Visitor": {
            "title": "チェックインが完了しました。",
            "message": "ありがとうございます。",
            "badge": {
              "title": "チェックインありがとうございます。バッジが印刷されます。",
              "message": ""
            }
          }
        },
        "checkout": {
          "default": {
            "title": "チェックアウトが完了しました。<br/>",
            "message": "またお会いしましょう。"
          },
          "MeetingAttendee": {
            "title": "チェックアウトが完了しました。",
            "message": "またお会いしましょう。"
          },
          "Employee": {
            "title": "チェックアウトが完了しました。",
            "message": "またお会いしましょう。"
          },
          "Visitor": {
            "title": "チェックアウトが完了しました。",
            "message": "またお会いしましょう。"
          },
          "access": {
            "title": "チェックアウトが完了しました。",
            "message": "ドアを開けることができます。"
          }
        }
      }
    }
  },
  "missingFields": {
    "title": "チェックインの前にもう少し情報をお願いします",
    "subtitle": "* の付いた項目は必須です",
    "btn": "チェックイン",
    "placeholder": {
      "other": "その他...",
      "otherInput": "選択肢を入力してください"
    },
    "error": {
      "required": "この項目が未入力です",
      "email": "無効なメールアドレスです",
      "phone": "無効な電話番号です"
    }
  },
  "manualCheckin": {
    "title": {
      "default": "入力してください。",
      "documentScanner": "身分証明書を挿入する際は次の点に注意してください："
    },
    "subtitle": {
      "default": "注意 - すべての項目 * は必須です",
      "documentScanner": [
        {
          "parts": [
            { "text": "<<< >>> の文字 (MRZ) が記載された", "bold": true },
            { "text": "面を", "bold": false },
            { "text": "キオスク／スキャナーに向けて", "bold": true },
            { "text": "ください。", "bold": false }
          ]
        },
        {
          "parts": [
            { "text": "フィールドが自動的に入力されるまで、", "bold": true },
            { "text": "カードをそのまま動かさないでください。", "bold": false }
          ]
        }
      ]
    },
    "noOption": "選択肢なし",
    "btn": "チェックイン",
    "placeholder": {
      "name": "お名前 *",
      "email": "メールアドレス *",
      "phone": "携帯電話番号",
      "contactName": "担当者 *",
      "other": "その他..."
    },
    "error": {
      "required": "この項目を入力していません",
      "name": "無効な名前",
      "email": "無効なメールアドレス",
      "phone": "無効な携帯電話番号"
    },
    "status": {
      "idle": {
        "no-contact": {
          "title": "お待ちください...",
          "message": "登録を処理しています。"
        },
        "contact": {
          "title": "お待ちください...",
          "message": "担当者に通知中です。"
        }
      },
      "loading": {
        "no-contact": {
          "title": "お待ちください...",
          "message": "登録を処理しています。"
        },
        "contact": {
          "title": "お待ちください...",
          "message": "担当者に通知中です。"
        }
      },
      "success": {
        "no-email-sms": {
          "title": "チェックインが完了しました。",
          "message": "ありがとうございます。"
        },
        "email-sms": {
          "title": "チェックインが完了しました。",
          "message": "担当者に通知されました。"
        },
        "call-ping": {
          "title": "チェックインが完了しました。",
          "message": "担当者との電話接続を開始します。"
        },
        "teams-call": {
          "title": "チェックインが完了しました。",
          "message": "担当者とのMicrosoft Teams通話を開始します"
        },
        "badge": {
          "title": "チェックインありがとうございます。バッジが印刷されます。",
          "message": ""
        },
        "video-call": {
          "title": "チェックインが完了しました。",
          "message": "担当者とのビデオ通話を設定しています。"
        }
      },
      "error": {
        "title": "問題が発生しました。",
        "message": "もう一度お試しください！"
      }
    },
    "documentScan": {
      "invalid": {
        "title": "無効な書類",
        "message": "書類を確認できなかったか、有効期限が切れています。手動で情報を入力してください。"
      }
    }
  },
  "manualCheckout": {
    "title": "チェックアウトするお名前を入力してください",
    "btn": "チェックアウト",
    "form": {
      "placeholder": {
        "name": "フルネーム *"
      },
      "loading": "読み込み中...",
      "noOptions": "選択肢なし"
    },
    "error": {
      "required": "この項目を入力していません",
      "name": "無効な名前"
    },
    "status": {
      "idle": {
        "title": "情報を処理しています。",
        "message": "お待ちください..."
      },
      "loading": {
        "title": "情報を処理しています。",
        "message": "お待ちください..."
      },
      "success": {
        "title": "チェックアウトが完了しました。",
        "message": "ありがとうございました。良い一日を。"
      },
      "successAccess": {
        "title": "チェックアウトが完了しました。",
        "message": "ドアを開けることができます。"
      },
      "error": {
        "title": "チェックアウト中にエラーが発生しました。",
        "message": "もう一度お試しください！"
      }
    }
  },
  "call": {
    "title": {
      "no-email-sms": "担当者に連絡しますか？",
      "email-sms": "担当者にメール/SMSを送信しました。<br/>追加で電話をかけますか？"
    },
    "callBtn": "通話",
    "pingBtn": "呼び出し",
    "smsBtn": "SMS",
    "callVideoBtn": "ビデオ通話",
    "teamsCallBtn": "Teams通話",
    "teamsMessageBtn": "Teamsメッセージ",
    "googleChatMessageBtn": "Google Chat",
    "noBtn": "キャンセル",
    "cancelBtn": "通話をキャンセル",
    "status": {
      "connecting": {
        "title": "通話を開始しています。<br/>お待ちください...",
        "message": ""
      },
      "ringing": {
        "title": "担当者に電話をかけています<br/>お待ちください...",
        "message": ""
      },
      "ringingReception": {
        "title": "通話を開始しました...",
        "message": ""
      },
      "open": {
        "title": "通話中です。",
        "message": ""
      },
      "close": {
        "title": "通話が終了しました。<br/>",
        "message": ""
      },
      "closeAccess": {
        "title": "通話が終了しました。<br/>ドアを開けることができます。",
        "message": ""
      },
      "closeReception": {
        "title": "通話が終了しました。",
        "message": ""
      },
      "error": {
        "title": "通話が繋がりませんでした。<br/>再度かけ直しますか？",
        "message": ""
      }
    }
  },
  "message": {
    "status": {
      "idle": {
        "title": "担当者に通知しています。",
        "message": "お待ちください..."
      },
      "loading": {
        "title": "担当者に通知しています。",
        "message": "お待ちください..."
      },
      "success": {
        "title": "SMSが送信されました。担当者に通知されました。",
        "message": "ありがとうございます！"
      },
      "successAccess": {
        "title": "SMSが送信されました。担当者に通知されました。",
        "message": "ドアを開けることができます。"
      },
      "error": {
        "title": "SMS送信に失敗しました。",
        "message": "もう一度お試しください！"
      }
    }
  },
  "videoCall": {
    "title": "ビデオ通話",
    "endCall": "通話終了",
    "status": {
      "idle": {
        "title": "ビデオルームを作成しています。",
        "message": "お待ちください..."
      },
      "loading": {
        "title": "ビデオルームを作成しています。",
        "message": "お待ちください..."
      },
      "success": {
        "title": "ビデオルームが正常に作成されました。",
        "message": "ルームに参加中..."
      },
      "error": {
        "title": "ビデオルームの作成に失敗しました。",
        "message": "もう一度お試しください！"
      }
    }
  },
  "teamsCall": {
    "title": "Teams通話",
    "controls": {
      "startCall": "通話開始",
      "endCall": "退出",
      "camera": "カメラ",
      "cameraOff": "カメラオフ",
      "mic": "マイク",
      "micOff": "マイクオフ",
      "ringing": "呼び出し中...",
      "noAnswer": "誰も通話に応答しませんでした。"
    },
    "status": {
      "connecting": {
        "title": "通話を開始しています。<br/>お待ちください...",
        "message": ""
      },
      "ringing": {
        "title": "担当者に電話をかけています<br/>お待ちください...",
        "message": ""
      },
      "connected": {
        "title": "通話開始中",
        "message": ""
      },
      "disconnected": {
        "title": "通話が終了しました。<br/>",
        "message": ""
      },
      "disconnectedAccess": {
        "title": "通話が終了しました。<br/>ドアを開けることができます。",
        "message": ""
      },
      "error": {
        "title": "通話が繋がりませんでした。<br/>もう一度お試しください",
        "message": ""
      },
      "noAnswer": {
        "title": "誰も通話に応答しませんでした。<br/>もう一度お試しください。",
        "message": ""
      }
    }
  },
  "teamsMessage": {
    "status": {
      "idle": {
        "title": "担当者に通知しています。",
        "message": "お待ちください..."
      },
      "loading": {
        "title": "担当者に通知しています。",
        "message": "お待ちください..."
      },
      "success": {
        "title": "メッセージが送信されました。担当者に通知されました。",
        "message": "ありがとうございます！"
      },
      "successAccess": {
        "title": "メッセージが送信されました。担当者に通知されました。",
        "message": "ドアを開けることができます。"
      },
      "error": {
        "title": "メッセージ送信に失敗しました。",
        "message": "もう一度お試しください！"
      }
    }
  },
  "googleChatMessage": {
    "status": {
      "idle": {
        "title": "担当者に通知しています。",
        "message": "お待ちください..."
      },
      "loading": {
        "title": "担当者に通知しています。",
        "message": "お待ちください..."
      },
      "success": {
        "title": "メッセージが送信されました。担当者に通知されました。",
        "message": "ありがとうございます！"
      },
      "successAccess": {
        "title": "メッセージが送信されました。担当者に通知されました。",
        "message": "ドアを開けることができます。"
      },
      "error": {
        "title": "メッセージ送信に失敗しました。",
        "message": "もう一度お試しください！"
      }
    }
  },
  "packageDelivery": {
    "title": "荷物の配達ありがとうございます！",
    "subtitle": "受取人を選択して通知してください",
    "subtitle1": "下のボタンを押して到着をお知らせください！",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "荷物の宛先"
      },
      "error": {
        "contact": {
          "required": "この項目を入力していません"
        }
      }
    },
    "button": {
      "submit": "通知"
    },
    "status": {
      "loading": {
        "title": "担当者に通知しています。",
        "message": "お待ちください..."
      },
      "success": {
        "no-email-sms": {
          "title": "配達ありがとうございました！",
          "message": ""
        },
        "email-sms": {
          "title": "担当者に通知されました。",
          "message": "配達ありがとうございました！"
        },
        "call-ping": {
          "title": "配達ありがとうございました！",
          "message": "担当者との電話接続を開始します。"
        },
        "teams-call": {
          "title": "配達ありがとうございました！",
          "message": "担当者とのMicrosoft Teams通話を開始します。"
        },
        "video-call": {
          "title": "配達ありがとうございました！",
          "message": "担当者とのビデオ通話を設定しています。"
        }
      },
      "error": {
        "title": "問題が発生しました。",
        "message": "もう一度お試しください！"
      }
    }
  },
  "foodDelivery": {
    "title": "食品の配達ありがとうございます！",
    "subtitle": "受取人を選択して通知してください",
    "subtitle1": "下のボタンを押して到着をお知らせください！",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "食品の宛先"
      },
      "error": {
        "contact": {
          "required": "この項目を入力していません"
        }
      }
    },
    "button": {
      "submit": "通知"
    },
    "status": {
      "loading": {
        "title": "担当者に通知しています。",
        "message": "お待ちください！"
      },
      "success": {
        "no-email-sms": {
          "title": "配達ありがとうございました！",
          "message": ""
        },
        "email-sms": {
          "title": "担当者に通知されました。",
          "message": "配達ありがとうございました！"
        },
        "call-ping": {
          "title": "配達ありがとうございました！",
          "message": "担当者との電話接続を開始します。"
        },
        "teams-call": {
          "title": "配達ありがとうございました！",
          "message": "担当者とのMicrosoft Teams通話を開始します。"
        },
        "video-call": {
          "title": "配達ありがとうございました！",
          "message": "担当者とのビデオ通話を設定しています。"
        }
      },
      "error": {
        "title": "問題が発生しました。",
        "message": "もう一度お試しください！"
      }
    }
  },
  "QRCodeScanner": {
    "title": "QRコードをスキャンしてください",
    "subtitle": "QRコードを赤い枠内に合わせて、電話を安定して持ってください。",
    "error": "無効なQRコード形式",
    "unknownError": "スキャン中に不明なエラーが発生しました"
  },
  "common": {
    "backBtn": "戻る"
  },
  "previewPDF": {
    "page": {
      "of": "の",
      "previous": "前",
      "next": "次"
    },
    "button": {
      "cancel": "キャンセル",
      "accept": "承認",
      "next": "次へ"
    },
    "title": {
      "consent": "同意が必要です"
    }
  },
  "offline": {
    "title": "オフライン",
    "receptionMessage": "デジタル受付は現在オフラインで使用できません。インターネット接続を確認してください！",
    "check": "訪問者の方で従業員と直接話したいですか？{{receptionistPhone}}にお電話ください"
  },
  "overview": {
    "title": "概要を開くコードを入力してください！",
    "noUsers": "登録なし",
    "status": {
      "success": {
        "title": "コードが有効です。",
        "message": ""
      },
      "error": {
        "title": "コードが無効です。",
        "message": "もう一度お試しください！"
      }
    },
    "checkoutStatus": {
      "loading": {
        "title": "お待ちください...",
        "message": ""
      },
      "success": {
        "title": "チェックアウト完了。",
        "message": ""
      },
      "error": {
        "title": "問題が発生しました。",
        "message": "もう一度お試しください！"
      }
    },
    "listTitle": "本日チェックインしたがチェックアウトしていない方のリスト",
    "page": "ページ ",
    "table": {
      "head": {
        "fullName": "名前",
        "type": "種類",
        "checkedinAt": "チェックイン時刻",
        "host": "担当者"
      },
      "type": {
        "Package": "荷物配達",
        "Food": "食品配達",
        "Visitor": "訪問者",
        "MeetingAttendee": "招待客",
        "Employee": "従業員",
        "Guest": "訪問者"
      }
    },
    "confirmModal": {
      "title": "{{fullName}}をチェックアウトしますか？",
      "cancel": "キャンセル",
      "checkout": "チェックアウト"
    }
  },
  "wifi": {
    "title": "Wi-Fiネットワークに接続"
  },
  "door": {
    "external": {
      "title": "ドアを開いています",
      "subtitle": "まもなくドアが開きます。お待ちください..."
    },
    "control": {
      "title": "ドアを開けることができます",
      "subtitle": "下のボタンを押してください！",
      "openBtn": "ドアを開ける"
    },
    "status": {
      "success": {
        "title": "ドアが開きました",
        "message": ""
      },
      "error": {
        "title": "問題が発生しました",
        "message": "担当者にドアを開けてもらうよう連絡してください。"
      },
      "loading": {
        "title": "ドアが開きます...",
        "message": ""
      }
    }
  },
  "photo": {
    "title": "チェックイン手続きの一環として写真を撮影しますか？",
    "required": {
      "title": "写真確認が必要です！",
      "instructions": "カメラの前に立って、画面の指示に従ってください。",
      "securityNotice": "セキュリティと確認のため、チェックイン時に写真が必要です。",
      "privacyInfo": "プライバシーを尊重します。データは安全に保存され、身元確認のためにのみ使用されます。",
      "closingMessage": "ご協力ありがとうございます。"
    },
    "optional": {
      "title": "チェックイン手続きの一環として写真を撮影しますか？",
      "instructions": "",
      "securityNotice": "写真撮影により身元確認を簡素化し、セキュリティを向上させることができます。",
      "privacyInfo": "プライバシーを尊重します。この手順はオプションで、データは安全に処理されます。",
      "closingMessage": "この手順をスキップすることもできます。"
    },
    "subtitle": "フレーム内に立って、最良の結果を得るため静止してください",
    "button": {
      "cancel": "キャンセル",
      "accept": "承認",
      "skip": "スキップ",
      "next": "次へ",
      "recapture": "再撮影",
      "continue": "続行"
    },
    "error": "写真撮影中にエラーが発生しました。チェックイン手続きは写真なしで続行されます。"
  },
  "wayfinding": {
    "title": "どちらに行きたいですか？"
  },
  "callingMenu": {
    "title": "通話メニュー"
  },
  "bell": {
    "status": {
      "success": {
        "title": "ベルが鳴っています",
        "message": "まもなく誰かが参ります"
      },
      "error": {
        "title": "エラーが発生しました",
        "message": "もう一度お試しください"
      },
      "loading": {
        "title": "接続中...",
        "message": "お待ちください"
      }
    }
  },
  "access": {
    "control": {
      "title": "ドアを開けることができます",
      "subtitle": "下のボタンを押してください。",
      "titleAuto": "自動ドアアクセス",
      "subtitleAuto": "ドアが自動的に開きます",
      "openBtn": "開ける"
    },
    "status": {
      "success": {
        "title": "ドアが開きました",
        "message": ""
      },
      "error": {
        "title": "問題が発生しました",
        "message": "担当者にドアを開けてもらうよう連絡してください。"
      },
      "loading": {
        "title": "ドアが開きます...",
        "message": ""
      }
    }
  }
}
